import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "global-loading"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("加载中...")

import { ref, provide } from 'vue'
import { computed, defineComponent, getCurrentInstance, watch, onMounted, reactive, toRefs } from 'vue';
import { useToken } from 'src/store';
import HttpClient from "src/http/http-client";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { proxy } : any = getCurrentInstance(); 
const loading = computed(()=>
{
    const { loadingCount } = useToken();
    return loadingCount || 0;
})


return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "router-view" }, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, {
        name: "router-fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1024),
      (_unref(loading) !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_van_loading, {
              size: "24px",
              vertical: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})